import {formatter, request} from '@/utils/request';

export namespace Invoices {
  export const Path = {
    Get: '/expenseapi/invoice/get',
    GetInvoice: '/expenseapi/invoice/GetInvoice',
    GetInvoiceFormDisplay: '/expenseapi/invoice/getInvoiceFormDisplay',
    Post: '/expenseapi/invoice/post',
    Delete: '/expenseapi/invoice/delete',
    DeleteFormInvoice: '/expenseapi/invoice/deleteFormInvoice',
    Close: '/expenseapi/invoice/close',
    ReOpen: '/expenseapi/invoice/reOpen',
    Validate: '/expenseapi/invoice/validateFormInvoices',
    QuoteInvoice: "/expenseapi/invoice/getQuoteInvoice",
    Identify: '/expenseapi/invoice/identify',
    QueryBaiWang: '/expenseapi/invoice/queryBaiWang',
    GetForPayment: "/expenseapi/invoice/getFormInvoicesForPayment",
  };

  export async function get(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.Invoice>>(Path.Get, formatter(options));
  }

  export async function getInvoice(param: API.InvoiceFilter) {
    const options = {
      method: 'GET',
      body: {
        ...param
      },
    };
    return request<API.ResponseResult<API.Invoice>>(Path.GetInvoice, formatter(options));
  }

  export async function getInvoiceFormDisplay(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<any>>(Path.GetInvoiceFormDisplay, formatter(options));
  }

  export async function post(body: { invoices: API.Invoice[] }) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.Invoice[]>>(Path.Post, formatter(options));
  }

  export async function del(invoiceId: number) {
    const options = {
      method: 'GET',
      body: {
        invoiceId: invoiceId
      },
    };
    return request<API.ResponseResult<any>>(Path.Delete, formatter(options));
  }

  export async function close(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id
      },
    };
    return request<API.ResponseResult<any>>(Path.Close, formatter(options));
  }

  export async function reOpen(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id
      },
    };
    return request<API.ResponseResult<any>>(Path.ReOpen, formatter(options));
  }

  export async function validate(body: API.Invoice) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<boolean>>(Path.Validate, formatter(options));
  }

  export async function quoteInvoice(body: API.InvoiceQuote) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.InvoiceVo[]>>(Path.QuoteInvoice, formatter(options));
  }

  export async function getForPayment(id: number) {
    const options = {
      method: 'GET',
      body: {
        formId: id,
      },
    };
    return request<API.ResponseResult<API.FormInvoiceVo[]>>(Path.GetForPayment, formatter(options));
  }

  export async function identify(body: API.InvoiceIdentifyParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.BaiWangInvoiceVo[]>>(Path.Identify, formatter(options));
  }

  export async function queryBaiWang(body: API.BaiWangInvoiceParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.BaiWangInvoiceVo[]>>(Path.QueryBaiWang, formatter(options));
  }

  export async function deleteFormInvoice(invoiceId: number, formInvoiceId: number) {
    const options = {
      method: 'GET',
      body: {
        invoiceId: invoiceId,
        formInvoiceId: formInvoiceId || 0
      },
    };
    return request<API.ResponseResult<any>>(Path.DeleteFormInvoice, formatter(options));
  }
}
